module.exports = __webpack_public_path__ + "img/qiuchang.cbffe68b.jpg";